import React from 'react';
import { Button } from '../../elements/ActionElement';

class PaginationButton extends React.Component {
  constructor() {
    super();
    this.activateButton = this.activateButton.bind(this);
  }

  activateButton() {
    const {
      refParentTable,
      goToPageNumber,
      classNames
    } = this.props;

    goToPageNumber();

    // Set the focus to the first sibling of the navigation button:
    if (refParentTable && refParentTable.current) {
      const className = classNames.join('.');
      const oFirstSiblingDom = refParentTable.current.querySelector(`.${className}`);
      oFirstSiblingDom.focus();

      // Scroll to the sibling even if it can not be focusable anymore (e.g. it turns into "disabled"):
      window.scrollTo(0, oFirstSiblingDom.offsetTop);
    }
  }

  render() {
    const {
      props,
      activateButton
    } = this;

    const {
      isDisabled,
      classNames,
      title,
      buttonContent
    } = props;

    const attributes = {
      title,
      onClick: activateButton,
      disabled: !!isDisabled,
      className: classNames.join(' '),
      letButtonShrink: true,
      buttonColor: isDisabled && 'gray'
    };

    return <Button {...attributes}>{buttonContent}</Button>;
  }
}

export default PaginationButton;